<template>
  <page-edicion>
    <formulario-divisa />
  </page-edicion>
</template>

<script>
import FormularioDivisa from "./FormularioDivisa";

export default {
  components: { FormularioDivisa },
};
</script>
